var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33325 7.99998C1.33325 4.31331 4.31325 1.33331 7.99992 1.33331C11.6866 1.33331 14.6666 4.31331 14.6666 7.99998C14.6666 11.6866 11.6866 14.6666 7.99992 14.6666C4.31325 14.6666 1.33325 11.6866 1.33325 7.99998ZM9.72659 5.33331L7.99992 7.05998L6.27325 5.33331L5.33325 6.27331L7.05992 7.99998L5.33325 9.72665L6.27325 10.6666L7.99992 8.93998L9.72659 10.6666L10.6666 9.72665L8.93992 7.99998L10.6666 6.27331L9.72659 5.33331Z",
    fill: "#8596B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIconFilled);
export default __webpack_public_path__ + "static/media/clear-Icon-filled.5f95f8262084c701db9e5de0c67c1030.svg";
export { ForwardRef as ReactComponent };